import React, { Component, memo } from 'react';
import ReactCodeInput from 'react-code-input';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { Button } from 'Components/Button';
import Counter from './Counter';
import { maskEmail } from 'Utils/maskEmail';
import EnvironmentManager from 'Utils/environmentManager';
class Otp extends Component {

  static propTypes = {
    otpText: PropTypes.object,
    expireTimeInSeconds: PropTypes.number,
    phone: PropTypes.string,
    email: PropTypes.string,
    errorText: PropTypes.string,
    onSubmit: PropTypes.func,
    sendOtpCode: PropTypes.func,
    updateMobilePhoneNumber: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.bool
    ])
  };

  constructor (props) {
    super(props);

    this.state = {
      isTimeOver: false,
      isCodeSubmitButtonDisabled: true,
      code: ''
    };
  }

  onSubmit = e => {
    e.preventDefault();

    this.props.onSubmit(this.state.code);
  }

  onSubmitAgain = e => {
    this.props.sendOtpCode(e);
    this.counter.startCounter();
    this.setState({
      isTimeOver: false,
      code: '',
      isCodeSubmitButtonDisabled: true
    });
  }

  timeIsOver = () => {
    this.setState({
      isTimeOver: true
    });
  }

  handleCodeInputChange = value => {
    this.setState({
      isCodeSubmitButtonDisabled: value.length < 6,
      code: value
    });
  }

  render () {
    const { errorText, phone, email, updateMobilePhoneNumber } = this.props;
    const { isTimeOver, isCodeSubmitButtonDisabled, code } = this.state;
    const errorMessage = errorText && (<div className='error-message'>{ errorText }</div>);
    const inputClass = classnames({
      'code-input': true,
      'code-input--error': errorText
    });
    const CMS_RESEND_OTP_SMS = EnvironmentManager.getMessageText({ key: 'description_forgot_password_resend_otp_sms' });

    const otpTemplate = isTimeOver
      ? (
        <>
          <div className='form__row text-error'>
            { this.props.phone && <p>{ CMS_RESEND_OTP_SMS }</p> }
            { this.props.email && <p>Doğrulama kodunu girmedin. Tekrar Gönder butonuna basarak yeni doğrulama kodu isteyebilirsin.</p> }
          </div>

          <div className='form__row drawer-bottom-button'>
            <Button title={ 'TEKRAR GÖNDER' } className='btn btn--primary btn--half-round btn--block' onClick={ this.onSubmitAgain }>Tekrar Gönder</Button>
          </div>
        </>
      )
      : (
        <form onSubmit={ this.onSubmit }>
          <div className='form__row'>

            { errorMessage }

            <ReactCodeInput
              ref={ c => this.code = c }
              name='otp'
              type='number'
              fields={ 6 }
              className={ inputClass }
              inputStyle={ {} }
              inputMode='numeric'
              inputStyleInvalid={ {} }
              autoFocus={ false }
              value={ code }
              onChange={ this.handleCodeInputChange }
            />
          </div>

          <div className='form__row drawer-bottom-button'>
            <Button
              title={ 'ONAYLA' }
              className='btn btn--primary btn--block'
              disabled={ isCodeSubmitButtonDisabled }
              type='submit'>
                Onayla
            </Button>
          </div>
        </form>
      );

    return (
      <div className='otp'>
        <div className='otp__text'>
          { this.props.phone && (this.props.otpText || (
            <>
              Cep telefonunu doğrulamak için <strong>{ phone }</strong> numaralı telefonuna gelen <strong>SMS onay kodunu</strong> aşağıdaki alana gir ve onayla
            </>
          )) }
          { this.props.email && (this.props.otpText || (
            <>
              E-posta adresini doğrulamak için <strong>{ maskEmail(email) }</strong> adresine gelen <strong>doğrulama kodunu</strong> aşağıdaki alana gir ve onayla
            </>
          )) }
        </div>
        <div className='otp__form form'>

          { updateMobilePhoneNumber && <p className='otp__link' onClick={ this.props.updateMobilePhoneNumber }>Bu numara senin değilse güncellemek için tıkla</p> }

          { otpTemplate }

        </div>

        <Counter duration={ this.props.expireTimeInSeconds } ref={ c => this.counter = c } timeIsOver={ this.timeIsOver } />
      </div>
    );
  }
}

export default memo(Otp);
